// prettier-ignore
// This file is auto-generated by build-docs.ts
export type DocumentationPaths = 'task-templates' | 'task-templates#task-templates' | 'task-templates#what-are-task-templates?' | 'task-templates#creating-task-templates' | 'task-templates#template-structure' | 'task-templates#sections' | 'task-templates#blocks' | 'task-templates#task-template-builder' | 'task-templates#using-task-templates' | 'task-templates#converting-tasks-to-templates' | 'task-templates#managing-task-templates' | 'task-templates#best-practices' | 'recipients' | 'recipients#recipients' | 'recipients#recipient-management' | 'recipients#adding-recipients' | 'recipients#recipient-profile' | 'recipients#recipient-groups' | 'recipients#recipient-experience' | 'recipients#recipient-settings' | 'recipients#recipient-notifications' | 'recipients#notification-management' | 'recipients#project-level-notification-control' | 'recipients#organization-level-opt-out' | 'recipients#notification-access-points' | 'recipients#timezone-settings' | 'recipients#recipient-data-privacy' | 'recipients#recipient-analytics' | 'recipients#managing-recipient-communications' | 'recipients#bulk-operations' | 'organizations' | 'organizations#organizations' | 'organizations#organization-members' | 'organizations#adding-organization-members' | 'organizations#member-roles-and-permissions' | 'organizations#role-capabilities' | 'organizations#admin-capabilities' | 'organizations#manager-capabilities' | 'organizations#member-capabilities' | 'organizations#removing-organization-members' | 'organizations#organization-settings' | 'organizations#general-settings' | 'organizations#custom-branding' | 'organizations#color-theme' | 'organizations#organization-groups' | 'organizations#creating-groups' | 'organizations#managing-group-members' | 'organizations#using-groups' | 'organizations#storage' | 'organizations#activity-tracking' | 'organizations#activity-types' | 'organizations#activity-filters' | 'organizations#activity-visibility' | 'organizations#notifications' | 'organizations#organization-labels' | 'project-templates' | 'project-templates#project-templates' | 'project-templates#what-are-project-templates?' | 'project-templates#creating-project-templates' | 'project-templates#default-task-settings' | 'project-templates#using-task-templates-in-project-templates' | 'project-templates#project-template-roles' | 'project-templates#creating-projects-from-templates' | 'project-templates#managing-project-templates' | 'project-templates#best-practices' | 'labels' | 'labels#labels' | 'labels#label-basics' | 'labels#label-management' | 'labels#using-labels' | 'labels#label-filtering' | 'labels#label-visibility' | 'labels#label-best-practices' | 'labels#bulk-label-operations' | 'labels#label-analytics' | 'labels#automated-labeling' | 'tasks' | 'tasks#tasks' | 'tasks#task-structure' | 'tasks#task-workflow' | 'tasks#preparation-phase' | 'tasks#active-phase' | 'tasks#completion-phase' | 'tasks#task-settings' | 'tasks#task-capabilities' | 'tasks#task-requests' | 'tasks#task-files' | 'tasks#notifications' | 'tasks#bulk-operations' | 'projects' | 'projects#projects' | 'projects#project-structure' | 'projects#project-status' | 'projects#project-owner' | 'projects#project-watchers' | 'projects#adding-watchers' | 'projects#default-task-settings' | 'projects#project-templates' | 'projects#project-labels' | 'projects#project-activity' | 'projects#activity-types' | 'projects#activity-filters' | 'projects#project-capabilities' | 'projects#notifications';

export const glossary = {
  "task-templates": {
    "path": "task-templates",
    "title": "Task Templates",
    "headings": [
      {
        "level": 1,
        "text": "Task Templates",
        "id": "task-templates"
      },
      {
        "level": 2,
        "text": "What are Task Templates?",
        "id": "what-are-task-templates?"
      },
      {
        "level": 2,
        "text": "Creating Task Templates",
        "id": "creating-task-templates"
      },
      {
        "level": 2,
        "text": "Template Structure",
        "id": "template-structure"
      },
      {
        "level": 3,
        "text": "Sections",
        "id": "sections"
      },
      {
        "level": 3,
        "text": "Blocks",
        "id": "blocks"
      },
      {
        "level": 2,
        "text": "Task Template Builder",
        "id": "task-template-builder"
      },
      {
        "level": 2,
        "text": "Using Task Templates",
        "id": "using-task-templates"
      },
      {
        "level": 2,
        "text": "Converting Tasks to Templates",
        "id": "converting-tasks-to-templates"
      },
      {
        "level": 2,
        "text": "Managing Task Templates",
        "id": "managing-task-templates"
      },
      {
        "level": 2,
        "text": "Best Practices",
        "id": "best-practices"
      }
    ]
  },
  "recipients": {
    "path": "recipients",
    "title": "Recipients",
    "headings": [
      {
        "level": 1,
        "text": "Recipients",
        "id": "recipients"
      },
      {
        "level": 2,
        "text": "Recipient Management",
        "id": "recipient-management"
      },
      {
        "level": 3,
        "text": "Adding Recipients",
        "id": "adding-recipients"
      },
      {
        "level": 3,
        "text": "Recipient Profile",
        "id": "recipient-profile"
      },
      {
        "level": 2,
        "text": "Recipient Groups",
        "id": "recipient-groups"
      },
      {
        "level": 2,
        "text": "Recipient Experience",
        "id": "recipient-experience"
      },
      {
        "level": 2,
        "text": "Recipient Settings",
        "id": "recipient-settings"
      },
      {
        "level": 2,
        "text": "Recipient Notifications",
        "id": "recipient-notifications"
      },
      {
        "level": 3,
        "text": "Notification Management",
        "id": "notification-management"
      },
      {
        "level": 3,
        "text": "Project-level Notification Control",
        "id": "project-level-notification-control"
      },
      {
        "level": 3,
        "text": "Organization-level Opt-out",
        "id": "organization-level-opt-out"
      },
      {
        "level": 3,
        "text": "Notification Access Points",
        "id": "notification-access-points"
      },
      {
        "level": 3,
        "text": "Timezone Settings",
        "id": "timezone-settings"
      },
      {
        "level": 2,
        "text": "Recipient Data Privacy",
        "id": "recipient-data-privacy"
      },
      {
        "level": 2,
        "text": "Recipient Analytics",
        "id": "recipient-analytics"
      },
      {
        "level": 2,
        "text": "Managing Recipient Communications",
        "id": "managing-recipient-communications"
      },
      {
        "level": 2,
        "text": "Bulk Operations",
        "id": "bulk-operations"
      }
    ]
  },
  "organizations": {
    "path": "organizations",
    "title": "Organizations",
    "headings": [
      {
        "level": 1,
        "text": "Organizations",
        "id": "organizations"
      },
      {
        "level": 2,
        "text": "Organization Members",
        "id": "organization-members"
      },
      {
        "level": 3,
        "text": "Adding Organization Members",
        "id": "adding-organization-members"
      },
      {
        "level": 3,
        "text": "Member Roles and Permissions",
        "id": "member-roles-and-permissions"
      },
      {
        "level": 3,
        "text": "Role Capabilities",
        "id": "role-capabilities"
      },
      {
        "level": 4,
        "text": "Admin Capabilities",
        "id": "admin-capabilities"
      },
      {
        "level": 4,
        "text": "Manager Capabilities",
        "id": "manager-capabilities"
      },
      {
        "level": 4,
        "text": "Member Capabilities",
        "id": "member-capabilities"
      },
      {
        "level": 3,
        "text": "Removing Organization Members",
        "id": "removing-organization-members"
      },
      {
        "level": 2,
        "text": "Organization Settings",
        "id": "organization-settings"
      },
      {
        "level": 3,
        "text": "General Settings",
        "id": "general-settings"
      },
      {
        "level": 3,
        "text": "Custom Branding",
        "id": "custom-branding"
      },
      {
        "level": 3,
        "text": "Color Theme",
        "id": "color-theme"
      },
      {
        "level": 2,
        "text": "Organization Groups",
        "id": "organization-groups"
      },
      {
        "level": 3,
        "text": "Creating Groups",
        "id": "creating-groups"
      },
      {
        "level": 3,
        "text": "Managing Group Members",
        "id": "managing-group-members"
      },
      {
        "level": 3,
        "text": "Using Groups",
        "id": "using-groups"
      },
      {
        "level": 2,
        "text": "Storage",
        "id": "storage"
      },
      {
        "level": 2,
        "text": "Activity Tracking",
        "id": "activity-tracking"
      },
      {
        "level": 3,
        "text": "Activity Types",
        "id": "activity-types"
      },
      {
        "level": 3,
        "text": "Activity Filters",
        "id": "activity-filters"
      },
      {
        "level": 3,
        "text": "Activity Visibility",
        "id": "activity-visibility"
      },
      {
        "level": 2,
        "text": "Notifications",
        "id": "notifications"
      },
      {
        "level": 2,
        "text": "Organization Labels",
        "id": "organization-labels"
      }
    ]
  },
  "project-templates": {
    "path": "project-templates",
    "title": "Project Templates",
    "headings": [
      {
        "level": 1,
        "text": "Project Templates",
        "id": "project-templates"
      },
      {
        "level": 2,
        "text": "What are Project Templates?",
        "id": "what-are-project-templates?"
      },
      {
        "level": 2,
        "text": "Creating Project Templates",
        "id": "creating-project-templates"
      },
      {
        "level": 2,
        "text": "Default Task Settings",
        "id": "default-task-settings"
      },
      {
        "level": 2,
        "text": "Using Task Templates in Project Templates",
        "id": "using-task-templates-in-project-templates"
      },
      {
        "level": 2,
        "text": "Project Template Roles",
        "id": "project-template-roles"
      },
      {
        "level": 2,
        "text": "Creating Projects from Templates",
        "id": "creating-projects-from-templates"
      },
      {
        "level": 2,
        "text": "Managing Project Templates",
        "id": "managing-project-templates"
      },
      {
        "level": 2,
        "text": "Best Practices",
        "id": "best-practices"
      }
    ]
  },
  "labels": {
    "path": "labels",
    "title": "Labels",
    "headings": [
      {
        "level": 1,
        "text": "Labels",
        "id": "labels"
      },
      {
        "level": 2,
        "text": "Label Basics",
        "id": "label-basics"
      },
      {
        "level": 2,
        "text": "Label Management",
        "id": "label-management"
      },
      {
        "level": 2,
        "text": "Using Labels",
        "id": "using-labels"
      },
      {
        "level": 2,
        "text": "Label Filtering",
        "id": "label-filtering"
      },
      {
        "level": 2,
        "text": "Label Visibility",
        "id": "label-visibility"
      },
      {
        "level": 2,
        "text": "Label Best Practices",
        "id": "label-best-practices"
      },
      {
        "level": 2,
        "text": "Bulk Label Operations",
        "id": "bulk-label-operations"
      },
      {
        "level": 2,
        "text": "Label Analytics",
        "id": "label-analytics"
      },
      {
        "level": 2,
        "text": "Automated Labeling",
        "id": "automated-labeling"
      }
    ]
  },
  "tasks": {
    "path": "tasks",
    "title": "Tasks",
    "headings": [
      {
        "level": 1,
        "text": "Tasks",
        "id": "tasks"
      },
      {
        "level": 2,
        "text": "Task Structure",
        "id": "task-structure"
      },
      {
        "level": 2,
        "text": "Task Workflow",
        "id": "task-workflow"
      },
      {
        "level": 3,
        "text": "Preparation Phase",
        "id": "preparation-phase"
      },
      {
        "level": 3,
        "text": "Active Phase",
        "id": "active-phase"
      },
      {
        "level": 3,
        "text": "Completion Phase",
        "id": "completion-phase"
      },
      {
        "level": 2,
        "text": "Task Settings",
        "id": "task-settings"
      },
      {
        "level": 2,
        "text": "Task Capabilities",
        "id": "task-capabilities"
      },
      {
        "level": 2,
        "text": "Task Requests",
        "id": "task-requests"
      },
      {
        "level": 2,
        "text": "Task Files",
        "id": "task-files"
      },
      {
        "level": 2,
        "text": "Notifications",
        "id": "notifications"
      },
      {
        "level": 2,
        "text": "Bulk Operations",
        "id": "bulk-operations"
      }
    ]
  },
  "projects": {
    "path": "projects",
    "title": "Projects",
    "headings": [
      {
        "level": 1,
        "text": "Projects",
        "id": "projects"
      },
      {
        "level": 2,
        "text": "Project Structure",
        "id": "project-structure"
      },
      {
        "level": 2,
        "text": "Project Status",
        "id": "project-status"
      },
      {
        "level": 2,
        "text": "Project Owner",
        "id": "project-owner"
      },
      {
        "level": 2,
        "text": "Project Watchers",
        "id": "project-watchers"
      },
      {
        "level": 3,
        "text": "Adding Watchers",
        "id": "adding-watchers"
      },
      {
        "level": 2,
        "text": "Default Task Settings",
        "id": "default-task-settings"
      },
      {
        "level": 2,
        "text": "Project Templates",
        "id": "project-templates"
      },
      {
        "level": 2,
        "text": "Project Labels",
        "id": "project-labels"
      },
      {
        "level": 2,
        "text": "Project Activity",
        "id": "project-activity"
      },
      {
        "level": 3,
        "text": "Activity Types",
        "id": "activity-types"
      },
      {
        "level": 3,
        "text": "Activity Filters",
        "id": "activity-filters"
      },
      {
        "level": 2,
        "text": "Project Capabilities",
        "id": "project-capabilities"
      },
      {
        "level": 2,
        "text": "Notifications",
        "id": "notifications"
      }
    ]
  }
};
